<template>
  <div class="content-card-plans">
    <a class="content-card-plans-link" @click="routerPage(meditation)">
      <div
        class="content-card-plans--image image--meditation"
        :style="{
          background: `url(data:image/jpg;base64,${meditation.picture})`,
        }"
      ></div>
      <div class="content-card-plans--category">
        <h2><span>Categoria: </span>{{ meditation.category_name }}</h2>
      </div>
      <div class="content-card-plans--text">
        <h3>{{ meditation.name }}</h3>
        <p>{{ meditation.description }}</p>
      </div>
    </a>
    <div class="content-card-plans-btn">
      <button class="btn-yellow" @click="routerPageTasks(meditation)">
        <p>Acessar Tarefas</p>
        <svg
          width="14"
          height="15"
          viewBox="0 0 6 11"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <mask
            id="mask0_25_130"
            style="mask-type: luminance"
            maskUnits="userSpaceOnUse"
            x="0"
            y="0"
            width="6"
            height="11"
          >
            <path d="M0 10.5715H6L6 0.751996H0L0 10.5715Z" fill="white" />
          </mask>
          <g mask="url(#mask0_25_130)">
            <path
              d="M5.78032 6.15696C6.07323 5.88307 6.07323 5.43826 5.78032 5.16438L1.2812 0.957382C0.9883 0.683502 0.5126 0.683502 0.2197 0.957382C-0.0732503 1.23131 -0.0732503 1.67607 0.2197 1.95L4.18922 5.66174L0.22205 9.37353C-0.0709 9.64742 -0.0709 10.0922 0.22205 10.3661C0.51495 10.64 0.99065 10.64 1.28354 10.3661L5.78266 6.15914L5.78032 6.15696Z"
            />
          </g>
        </svg>
      </button>
    </div>
  </div>
</template>

<script>
export default {
  props: ["meditation"],
  methods: {
    routerPage(meditation) {
      this.$router.push({
        name: "EditMeditation",
        params: {
          id: meditation.id,
        },
      });
    },
    routerPageTasks(meditation) {
      this.$router.push({
        name: "MeditationTasks",
        params: {
          id: meditation.id,
        },
      });
    },
  },
};
</script>

<style lang="scss">
.content-card-plans {
  display: block;
  background: var(--white);
  box-shadow: 0px 1px 3px rgba(0, 0, 0, 0.25);
  border-radius: 10px;
  margin-bottom: 30px;
  &-link {
    display: block;
    transition: 500ms;
    &:hover,
    &:focus {
      cursor: pointer;
      opacity: 0.8;
    }
  }
  &--category {
    padding: 15px 15px 10px 15px;
    text-align: left;
    border-bottom: 1px solid rgba(0, 0, 0, 0.05);
    h2 {
      font-size: 14px;
      font-family: "Font SemiBold";
      color: var(--yellow-dark);
      margin-bottom: 0;
      @media (min-width: 577px) {
        height: 50px;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        overflow: hidden;
      }
      span {
        font-size: 14px;
        font-family: "Font Light";
        color: var(--black);
        margin-bottom: 0;
      }
    }
  }
  &--image {
    width: 100%;
    height: 150px;
    background-repeat: no-repeat !important;
    background-position: center !important;
    border-radius: 10px 10px 0px 0px;
    &.image--meditation {
      background-size: contain !important;
    }
  }
  &--text {
    padding: 15px;
    text-align: left;
    h3 {
      font-size: 16px;
      font-family: "Font Regular";
      color: var(--black);
      margin-bottom: 10px;
      @media (min-width: 577px) {
        height: 40px;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        overflow: hidden;
      }
    }
    p {
      font-size: 14px;
      font-family: "Font Light";
      color: var(--black);
      margin-bottom: 0;
      @media (min-width: 577px) {
        height: 65px;
        display: -webkit-box;
        -webkit-line-clamp: 3;
        -webkit-box-orient: vertical;
        overflow: hidden;
      }
    }
  }
  &-btn {
    padding: 15px;
    .btn-yellow {
      margin-bottom: 0;
    }
  }
}
</style>
